<script setup lang="ts">
import AppInitializingModule from '@/components/AppInitializingModule.vue'
import AppModuleTable from '@/components/AppModuleTable.vue'
import { cilSettings } from '@coreui/icons'
import { dateParse, dateSpanishFormatter } from '@/helpers/Date'
import Cookie from '@/components/Cookie/Cookie.vue'

const columns = [
  { key: 'name', label: 'Name' },
  { key: 'status', label: 'Status', _style: { 'text-align': 'center' } },
  {
    key: 'start_date',
    label: 'Start Date',
    search: 'date',
    _style: { 'text-align': 'center' }
  },
  { key: 'actions', label: '' }
]

function getStatusBadgeColor(item) {
  switch (item.status) {
    case 'development':
      return 'warning'
    case 'finished':
      return 'success'
    case 'public':
      return 'danger'
  }
}

const events = ref(null)

async function getNextEvents() {
  const url = '/api/v1/query/events'
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)
  const futureDate = new Date()
  futureDate.setDate(today.getDate() + 30)

  const body = {
    start_date_to: dateParse(futureDate),
    end_date_from: dateParse(yesterday),
    sort: [{ name: 'start_date', order: 'asc' }]
  }

  const { data, success, promise } = useFetch(url, body, 'POST')
  await promise
  if (success.value) {
    return Promise.resolve(data.value.data)
  }
  return Promise.reject('Error fetching the Events')
}

onMounted(async () => {
  events.value = await getNextEvents()
})
</script>

<template>
  <Cookie />
  <main>
    <div class="row">
      <div class="col-10">
        <AppModuleTable
          v-if="events"
          disableSelectAll
          :section="$t('Coming events')"
          :columns="columns"
          :items="events.data"
          :tableProps="{
            striped: false,
            hover: true,
            stripedColumns: false
          }"
          :tableDisableSearch="true"
          header
        >
          <template #status="{ item }">
            <td align="center" width="120px">
              <CBadge :color="getStatusBadgeColor(item)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #name="{ item }">
            <td style="white-space: nowrap">
              <router-link :to="`/events/${item.id}`">
                {{ item.name }}
              </router-link>
            </td>
          </template>
          <template #start_date="{ item }">
            <td align="center">
              {{ dateSpanishFormatter(item.start_date) }}
            </td>
          </template>
          <template #actions="{ item }">
            <td>
              <router-link :to="`/events/${item.id}`">
                <CButton color="dark">
                  <CIcon :icon="cilSettings" />
                </CButton>
              </router-link>
            </td>
          </template>
        </AppModuleTable>
        <AppInitializingModule v-else />
      </div>
    </div>
  </main>
</template>
